module.exports = __webpack_public_path__ + "static/media/banner_en_US.aede1c54.png";